'use strict';

export const CREATE_ORG_NAME = 'createOrg';
export const CREATE_ORG_PREFIX = `@@${CREATE_ORG_NAME}`;

export const UPDATE_ORG_NAME = 'updateOrg';
export const UPDATE_ORG_PREFIX = `@@${UPDATE_ORG_NAME}`;



// WEBPACK FOOTER //
// ./src/js/organizations/redux/state.js